import { modes } from 'app.config';
import assets from 'assets';
import ChatFilterMenu from 'container/components/ChatFilterMenu/ChatFilterMenu';
import React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';

function Chats({ setSignUpModal }) {
  const isLoggedIn = localStorage.getItem('token');
  const dispatch = useDispatch();
  const isOpen = useSelector(state => state.utils.isLeftSideBarOpen);
  const conversations = useSelector(state => state.chat.conversations);
  const documents = useSelector(state => state.documents.documents);
  const mode = useSelector(state => state.utils.mode);

  // const handleChangeFilter = (filter) => {
  //   dispatch.chat.setTimeFilter(filter);
  // };

  return (
    <div
      className='chats-container'
      style={{ alignItems: 'center', height: '50px' }}
    >
      <div className='left-side'>
        <Icon
          className={mode === modes.document ? 'doc' : ''}
          onClick={() => dispatch.utils.setLeftSideBar(true)}
        >
          <img
            src={mode === modes.document ? assets.documentText : assets.message}
            width={20}
            alt=''
          />
        </Icon>
        {isOpen && (
          <>
            <h1 className='chat-heading'>
              {mode === modes.document ? 'Documents' : 'Chats'}
            </h1>
            {isLoggedIn && (
              <div className='eye-circle'>
                {mode !== modes.document
                  ? conversations.length
                  : documents.length}
              </div>
            )}
          </>
        )}
      </div>
      {isOpen && !isLoggedIn && (
        <div onClick={() => setSignUpModal(true)} style={{ cursor: 'pointer' }}>
          <p
            style={{
              color: '#FF434E',
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '18px',
              margin: '0px',
            }}
          >
            Sign up to save your chats
          </p>
        </div>
      )}
      {isOpen && mode !== modes.document && (
        <div className='custom-select'>
          <ChatFilterMenu />
        </div>
      )}
    </div>
  );
}

export default Chats;

const Icon = styled.div`
  height: 30px;
  width: 30px;
  display: grid;
  place-items: center;
  background-color: #74aa9c;
  border-radius: 8px;
  transition: 0.4s ease;

  &.doc {
    background-color: #0094ff;
  }
`;
